import _findIndex from 'lodash/findIndex';
import * as types from '../constants/ActionTypes';

const initialState = {
  currentIcfId: '',
  expandedFaqId: '',
  accessedList: [], // [{ icfId: 'ICF_ID', accessed: ['clicked_FAQ_ID', ...] }]; ICF id with visited article id
  promptTreatment: '',
};

const updateAccessedList = (state, payload) => {
  if (!state.currentIcfId) {
    return [];
  }

  const copyList = [...state.accessedList]; // Make deep copy avoiding change origin state data
  const icfIndex = _findIndex(copyList, item => item.icfId === state.currentIcfId);

  // New ICF access list
  if (icfIndex < 0) {
    const icfItem = {
      icfId: state.currentIcfId,
      accessed: [payload],
    };
    return [...copyList, icfItem];
  }

  // Existing ICF access list
  const accessed = copyList[icfIndex].accessed;
  if (accessed.indexOf(payload) < 0) { // If the current faqId is not visied, then add the faqId into accessed list
    copyList[icfIndex].accessed = [...accessed, payload];
  }
  return copyList;
};

const expansionHandler = (state, articleId, icfId) => {
  if (state.expandedFaqId === articleId) { // Collapse the article content, if the article is being expanded
    return Object.assign({}, state, { expandedFaqId: '' });
  }

  return Object.assign({}, state, { expandedFaqId: articleId, accessedList: updateAccessedList(state, articleId, icfId) }); // Update accessedList and store current FAQ id
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.EXPAND_FAQ_CONTENT:
      return expansionHandler(state, action.payload.articleId, action.payload.icfId);
    case types.ICF_SELECTED:
      return Object.assign({}, state, { isIcfSelected: true, currentIcfId: action.payload });
    case types.ICF_PROMPT_CONFIG_CHECKER:
      return Object.assign({}, state, { promptTreatment: action.payload });
    case types.UPDATE_VISITED_ACCESS_LIST: {
      return Object.assign({}, state, { accessedList: action.payload });
    }
    default:
      return state;
  }
}
